import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { useStudioStore } from '~entities/studios/model/studio-store';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { FormSubmissionsResponse } from './types';

export interface GetFormSubmissionsParams {
  page?: number;
  limit?: number;
  formType?: string;
  syncStatus?: string;
  search?: string;
  from?: string;
  to?: string;
}

export const getFormSubmissionsAPI = async (
  params?: GetFormSubmissionsParams,
) => {
  const response = await baseAPI.get<FormSubmissionsResponse>(
    'forms/submissions',
    { params },
  );
  return response.data;
};

export const getFormSubmissionsOptions = (
  studioId: string | null | undefined,
  params?: GetFormSubmissionsParams,
) => {
  return queryOptions({
    queryKey: QUERY_KEYS.FORM_SUBMISSIONS(studioId, params),
    queryFn: () => getFormSubmissionsAPI(params),
    placeholderData: keepPreviousData,
  });
};

export const useGetFormSubmissions = (params?: GetFormSubmissionsParams) => {
  const currentStudioId = useStudioStore((state) => state.currentStudioId);
  return useQuery({
    ...getFormSubmissionsOptions(currentStudioId, params),
    // Studio-scoped data — key carries the studio identity and the query only
    // runs once studio context resolves, so a prior tenant's cache can never
    // surface after a logout/login.
    enabled: Boolean(currentStudioId),
  });
};
